import { Banner } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { BannerQuizProps } from './types';

const BannerQuiz = ({ option, correctAnswer, context, tContext }: BannerQuizProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);

  const isCorrect = option === correctAnswer;
  const id = isCorrect ? 'success-answer' : 'error-answer';
  const mode = isCorrect ? 'success' : 'cold';
  const label = isCorrect
    ? t(`Quiz.${context}.banner.success.title`, {
        context: tContext,
      })
    : t(`Quiz.banner.error.title`, {
        context: tContext,
      });
  const description = isCorrect
    ? t(`Quiz.${context}.banner.success.description`, {
        context: tContext,
      })
    : t(`Quiz.${context}.banner.error.description`, {
        context: tContext,
      });

  return <Banner id={id} mode={mode} label={label} description={description} layout="embed" />;
};

export default BannerQuiz;
